"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var network_1 = require("./network");

var addressToTokenMap = new Map([[network_1.Network.Mainnet, "0x06d1f34fd7C055aE5CA39aa8c6a8E10100a45c01"], [network_1.Network.Ropsten, "0xD01CdF5D0070771787358a577A27B2d2ef927A83"], [network_1.Network.Rinkeby, "0xE41b1Fb0b53759f52e82c210E152690bd0A162cB"]]);

var InvokerUtils =
/** @class */
function () {
  function InvokerUtils() {}

  InvokerUtils.getAddress = function (network) {
    if (!addressToTokenMap.has(network)) {
      return null;
    }

    return addressToTokenMap.get(network);
  };

  return InvokerUtils;
}();

exports.InvokerUtils = InvokerUtils;